export enum ContentType {
  QUIZ = 'quiz',
  PRESENTATION = 'presentation',
  COURSE = 'course',
}
